export default __webpack_public_path__ + "static/media/awone.6c44721e.svg";